module.exports = __webpack_public_path__ + "static/goran_mladenovic-7843874b783f3d795681b1302a4022f5.png";